const initialState = {
  error: '',
  loading: false,
  user: {},
  isLoggedIn: false,
  success: false,
};

export default initialState;
